import { Grid, ToggleButton, ToggleButtonGroup, styled } from "@mui/material";

import { TRADE_SIDE } from "../constants";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

function SideButtons({ tradeInitial }) {
  const { setValue, watch } = useFormContext();
  const sideId = +watch("sideId");

  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (_, newValue) => {
    if (newValue) {
      const allSearchParams = Object.fromEntries([...searchParams]);
      setSearchParams({ ...allSearchParams, sideId: newValue });

      setValue("sideId", newValue);
    }
  };

  const sideColor = useMemo(() => {
    const currentSide = Object.values(TRADE_SIDE).find((s) => s?.id === sideId);

    return currentSide.color;
  }, [sideId]);

  return (
    <Grid container my={1}>
      <Grid item xs={12}>
        <ToggleButtonGroupStyle
          color="text"
          value={sideId}
          exclusive
          onChange={handleChange}
        >
          {tradeInitial?.lisSide?.map((side) => (
            <ToggleButtonStyle color={sideColor} value={side?.id}>
              {side?.name}
            </ToggleButtonStyle>
          ))}
        </ToggleButtonGroupStyle>
      </Grid>
    </Grid>
  );
}

const ToggleButtonGroupStyle = styled(ToggleButtonGroup)(({ theme }) => ({
  width: "100%",
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  borderRadius: "8px !important",
  border: `1px solid ${theme.palette.common.white}10`,
}));

const ToggleButtonStyle = styled(ToggleButton)(({ theme }) => ({
  width: "100%",
  border: "none",
  borderRadius: "8px !important",
  marginLeft: theme.spacing(-2),
  marginRight: theme.spacing(-2),
  color: theme.palette.text.main,
  padding: theme.spacing(0.5),
  lineHeight: 0,
  minHeight: "30px",
  textTransform: "none",
  backgroundColor: theme.palette.modules.input,

  "&.Mui-selected": {
    color: theme.palette.common.white,
    zIndex: 1,

    "&.MuiToggleButton-success": {
      backgroundColor: theme.palette.success.main,
    },

    "&.Mui-error": {
      backgroundColor: theme.palette.error.main,
    },
  },
}));

export default SideButtons;
